import React, {useEffect, useRef, useState} from 'react';
import {useIdleTimer} from 'react-idle-timer';
import {Button, Modal} from "antd";
import {FieldTimeOutlined} from "@ant-design/icons";
import userAccessService from "../../../service/UserAccessService";

const IdleTimeComp: React.FC<{ logoutClicked: () => void }> = ({logoutClicked}) => {
    const [isIdle, setIsIdle] = useState(false);
    const idleTimerRef = useRef<any>(null);
    const [countdown, setCountdown] = useState(60);
    const [sessionTimeout, setSessionTimeout] = useState(300); // 5 mins default
    const [idleCallCount, setIdleCallCount] = useState(0);
    const countdownIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const countdownStartRef = useRef<number | null>(null);
    const onIdle = () => {
        setIdleCallCount(prevCount => {
            return ++prevCount;
        })
        setIsIdle(true)
        if (idleCallCount === 0) {
            startCountdown()
        }
    };

    useIdleTimer({
        ref: idleTimerRef,
        timeout: 1000 * sessionTimeout,
        onIdle: onIdle,
        debounce: 500,
    });

    useEffect(() => {
        fetchSessionTimeout()
        return () => {
            if (countdownIntervalRef.current) {
                clearInterval(countdownIntervalRef.current);
            }
        };
    }, []);

    const fetchSessionTimeout = () => {
        userAccessService.getSessionTime().then(res => {
            if (null != res.data) {
                setSessionTimeout(res.data)
            }else {
                setSessionTimeout(300)
            }
        }).catch((reason) => {
            setSessionTimeout(300)
        })
    }

    const handleCancel = () => {
        setIsIdle(false);
        setIdleCallCount(0);
        resetCountdown();
        logoutClicked();
    };

    const handleOk = () => {
        setIsIdle(false)
        setIdleCallCount(0);
        resetCountdown();
    }
    const startCountdown = () => {
        resetCountdown();
        countdownStartRef.current = Date.now();

        countdownIntervalRef.current = setInterval(() => {
            if (countdownStartRef.current !== null) {
                const elapsedTime = Math.floor((Date.now() - countdownStartRef.current) / 1000);
                const remainingTime = 60 - elapsedTime;

                if (remainingTime <= 0) {
                    handleCancel();
                    setCountdown(0);
                } else {
                    setCountdown(remainingTime);
                }
            }
        }, 1000);
    };

    const resetCountdown = () => {
        setCountdown(60);
        if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
        }
    };

    const formatTime = (seconds: number): string => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;

        return minutes > 0 ? `${minutes}m ${remainingSeconds}s` : `${remainingSeconds}s`;
    };
    return (
        <Modal
            open={isIdle}
            title={null}
            onOk={handleOk}
            onCancel={handleCancel}
            destroyOnClose={true}
            maskClosable={false}
            closable={false}
            className={'still-with-us-modal'}
            footer={null}
            centered
        >
            <div className="still-modal-icon-div">
                <FieldTimeOutlined className={'still-modal-icon'}/>
            </div>
            <div className="still-modal-header">
                <span>
                    Still with us?
                </span>
            </div>
            <p className={'still-modal-content'}>Privacy is essential, and you've been gone a while. We will log you out
                in <b>{formatTime(countdown)}</b> unless you confirm you're still with us.</p>

            <div className="still-modal-btn-footer">

                <Button key="submit" type="primary" size={'large'} onClick={handleOk}>
                    Continue working
                </Button>
                <Button key="back" type={'link'} size={'large'} onClick={handleCancel}>
                    Logout now
                </Button>
            </div>
        </Modal>
    );
};

export default IdleTimeComp;
